

export default {
  fetchCurrentPage ({ commit, state }, data) {
    // console.log(state.api)
  },
  setToken({ commit, state }, data) {
    console.log(data);
    commit('setToken', data.token)

    const set = (name ,text, date) => {
      date = date.toUTCString();
      document.cookie = `${name}=${text}; domain=${state.domain}; expires=${date}; path=/`;
    }

    if(data.isRemember)
    {
      if(data.token) {
        let date = new Date(Date.now() + 86400e3 * 30);
        set('token', data.token, date);
      } else {
        let date = new Date(Date.now() - 86400e3 * 30);
        document.cookie = `${'token'}=${'token'}; domain=${state.domain}; expires=${date}; path=/`;
      }
    }
  },
  setUser({ commit }, data) {
    commit('setUser', data)
  },
}


// WEBPACK FOOTER //
// ./src/store/actions.js